import QuestionValue from "../QuestionValue";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleExponent extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);
        this.generateOptions(question, data.type);
        return question;
    }

    generateOptions(question, type) {

        if (type === "squared") { //square
            const term = P3.math.randomInt(question.range.min, question.range.max);
            const result = term * term;

            question.values.push(new QuestionValue(term + "²"));
            question.values.push(new QuestionValue(result));

            question.part = 1;

            let k = 100;
            let arr = [];
            while (k-- > 0 && question.options.length < 5) {
                const rand = P3.math.randomInt(question.range.min, question.range.max);
                const decoy = rand * rand + P3.math.randomInt(0, 4);
                if (arr.indexOf(decoy) === -1 && decoy !== result) {
                    arr.push(decoy);
                    question.options.push(new QuestionValue(decoy));
                }
            }

            question.options.push(new QuestionValue(result));
            P3.utils.shuffleArray(question.options);

        }
        else if (type === "cubed") {//cube
            const term = P3.math.randomInt(question.range.min, question.range.max);
            const result = term * term * term;

            question.values.push(new QuestionValue(term + "³"));
            question.values.push(new QuestionValue(result));

            question.part = 1;

            let k = 100;
            let arr = [];
            while (k-- > 0 && question.options.length < 5) {
                const rand = P3.math.randomInt(question.range.min, question.range.max);
                const decoy = rand * rand * rand + P3.math.randomInt(0, 4);
                if (arr.indexOf(decoy) === -1 && decoy !== result) {
                    arr.push(decoy);
                    question.options.push(new QuestionValue(decoy));
                }
            }

            question.options.push(new QuestionValue(result));
            P3.utils.shuffleArray(question.options);
        }
        else if (type === "square_root") {//cube
            const term = P3.math.randomInt(question.range.min, question.range.max);
            const value = term * term;

            question.values.push(new QuestionValue(value));
            question.values.push(new QuestionValue(term));

            question.part = 1;

            let k = 100;
            let arr = [];
            while (k-- > 0 && question.options.length < 5) {
                const rand = P3.math.randomInt(question.range.min, question.range.max);
                if (arr.indexOf(rand) === -1 && rand !== term) {
                    arr.push(rand);
                    question.options.push(new QuestionValue(rand));
                }
            }

            question.options.push(new QuestionValue(term));
            P3.utils.shuffleArray(question.options);
        }
        else if (type === "cube_root") {//cube
            const term = P3.math.randomInt(question.range.min, question.range.max);
            const value = term * term * term;

            question.values.push(new QuestionValue(value));
            question.values.push(new QuestionValue(term));

            question.part = 1;

            let k = 100;
            let arr = [];
            while (k-- > 0 && question.options.length < 5) {
                const rand = P3.math.randomInt(question.range.min, question.range.max);
                if (arr.indexOf(rand) === -1 && rand !== term) {
                    arr.push(rand);
                    question.options.push(new QuestionValue(rand));
                }
            }

            question.options.push(new QuestionValue(term));
            P3.utils.shuffleArray(question.options);
        }
        else {
            console.warn("exponential supports square and cube only");
        }
    }
}